import React, { useState } from "react";
import { isEmpty, getPath } from "../../../utils";
import { Pill } from "../../../constants/assets/containers";
import styled from "styled-components";
import * as LifeLineAction from "../../../store/actions/LifeLine";
import * as UserActions from "../../../store/actions/User";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const SupportTags = (props) => {
  const { orderID, customTags } = props;
  const [tagIDs, setTagIDs] = useState(props.tagIDs || []);
  const [isOpen, setIsOpen] = useState(false);

  function isOptionDisabled(tagName) {
    let targetTagID = Object.keys(SupportTagIDMappings).find(
      (key) => SupportTagIDMappings[key] === tagName
    );
    let targetTagIDint = targetTagID ? parseInt(targetTagID, 10) : null;
    return tagIDs.includes(targetTagIDint);
  }

  const handleTagSelect = (selectedTag) => {
    if (selectedTag) {
      let selectedTagID = Object.keys(SupportTagIDMappings).find(
        (key) => SupportTagIDMappings[key] === selectedTag
      );
      let selectedTagIDint = selectedTagID ? parseInt(selectedTagID, 10) : null;

      props.addSupportTags(orderID, [selectedTagIDint]).then((res) => {
        if (res && getPath(res, "status.code", "") === 200) {
          setTagIDs((prevTagIDs) => [...prevTagIDs, selectedTagIDint]);
        }
      });
    }
    setIsOpen(false);
  };

  const handleDoClick = () => {
    setIsOpen(!isOpen);
  };

  const useStyles = makeStyles({
    smallFont: {
      fontSize: 10,
    },
    autoComplete: {
      width: 200,
      marginTop: "10px",
    },
  });

  const classes = useStyles();

  return (
    <>
      <TagWrapper>
        {!isEmpty(customTags) &&
          customTags.map((tag) => <StyledPill key={tag}>{tag}</StyledPill>)}
        {!isEmpty(tagIDs) &&
          tagIDs.map((tagID) =>
            SupportTagIDMappings[tagID] ? (
              <StyledPill key={tagID}>{SupportTagIDMappings[tagID]}</StyledPill>
            ) : null
          )}
        {!isOpen && (
          <StyledPill
            style={{ cursor: "pointer", background: "white" }}
            onClick={handleDoClick}
            isFalse={true}
          >
            + Add Tag
          </StyledPill>
        )}
      </TagWrapper>
      {isOpen && (
        <div className={classes.autoComplete}>
          <Autocomplete
            autoHighlight
            filterSelectedOptions
            classes={{
              input: classes.smallFont,
              option: classes.smallFont,
            }}
            onChange={(event, newValue) => {
              handleTagSelect(newValue);
            }}
            onClose={() => {
              setIsOpen(false);
            }}
            getOptionDisabled={(option) => isOptionDisabled(option)}
            closeIcon={false}
            id="tagsAutoSearch"
            options={Object.values(SupportTagIDMappings)}
            disableClearable={true}
            renderInput={(params) => (
              <TextField {...params} label="Select Tag" variant="outlined" />
            )}
          />
        </div>
      )}
    </>
  );
};

const SupportTagIDMappings = {
  1: "DELAY_MINT_TAG",
  17: "ORDER_STATUS_MINT_TAG",
  27: "NOT_DISPATCHED_MINT_TAG",
  29: "WALLET_ISSUE_MINT_TAG",
  30: "RIDER_BEHAVIOUR_MINT_TAG",
  33: "PACKAGING_ISSUE_MINT_TAG",
  37: "PICKUP_CONFUSION_MINT_TAG",
  45: "WRONG_ORDER_INVOICE_MISMATCH_MINT_TAG",
  51: "DELAY_IN_HAND_OVER_TAG",
  53: "WRONG_USER_ADDRESS",
  54: "LONG_DISTANCE_ORDER",
  55: "MX_HIGH_WAIT_TIME",
  56: "CUSTOMER_NOT_RESPONDING",
  57: "ACCIDENT_VEHICLE_ISSUE",
  58: "ITEM_OUT_OF_STOCK",
  59: "PICKUP_OTP",
  60: "HIGH_ORDER_VALUE",
  61: "UNSAFE_AREA",
  62: "CUSTOMER_DENYING_ORDER",
  63: "RAIN_TRAFFIC_DELAY",
  64: "INCORRECT_MERCHANT_ADDRESS",
  65: "OUTLET_CLOSED",
  66: "VALET_CANT_CALL",
  67: "ORDER_SNATCHED",
  68: "MERCHANT_NOT_GIVING_ORDER",
  69: "CALL_DROP",
  70: "NON_ORDER_CALL",
  72: "OTHER_RIDER_PICKED_ORDER",
  73: "REGIONAL_CALL",
  74: "MULTI_ORDER",
  76: "ORDER_RELATED_INFO",
  77: "FE_WRONG_PUNCH",
  78: "MERCHANT_DEVICE_ISSUE",
  80: "MERCHANT_DENYING_RETURN",
  91: "VALET_NOT_RESPONDING",
  94: "CANT_MARK_DELIVERED",
  102: "PAYMENT_FAILURE",
  103: "VALET_NOT_ASSIGNED",
  109: "CANT_FIND_CX_ADDRESS",
  122: "DROP_OTP",
  123: "MX_LONG_DISTANCE",
  140: "ABUSIVE_BEHAVIOUR",
  148: "MX_DENIED_CONF_CALL",
  149: "CX_DENIED_CONF_CALL",
  151: "INCOMPLETE_CX_ADDRESS",
  152: "UNABLE_TO_FIND_MX_ADDRESS",
  161: "MX_WAS_RUDE_ABUSIVE",
  162: "CONNECTIVITY_ISSUES_WITH_MX",
  163: "CONNECTIVITY_ISSUES_WITH_RIDER",
  164: "RIDER_WAS_RUDE_ABUSIVE",
  165: "RIDER_NOT_CARRYING_INSULATION_BAG",
  166: "FACING_TECHNICAL_ISSUES",
  169: "MX_PHYSICALLY_ASSAULTED_DP",
  170: "MX_THREATENED_OR_ABUSIVE_DP",
  176: "NO_BAG_SHIRT",
  179: "DP_STRIKE_ISSUE",
  181: "DP_PERSONAL_EMERGENCY",
  186: "CHANGE_ISSUE_COD",
  190: "DP_ASKING_FOR_CASH",
  192: "LANGUAGE_BARRIER",
  174: "CONCIERGE_REJECTION",
  175: "CONCIERGE_EXTREME_DELAY",
};

const TagWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const StyledPill = styled(Pill)`
  border-radius: 30px;
  font-size: 10px !important;
`;

const mapDispatchToProps = (dispatch) => ({
  addSupportTags: bindActionCreators(LifeLineAction.addSupportTags, dispatch),
  setStatus: bindActionCreators(UserActions.setStatus, dispatch),
});

export default connect(null, mapDispatchToProps)(SupportTags);
